import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToasterModule as ToastModule } from 'angular2-toaster';
import { ToasterComponent } from './toaster.component';
import { ToasterService } from './toaster.service';
import { ToasterStore } from './toaster.store';
import { ToasterEffects } from './toaster.effects';
import { FEATURE_NAME, reducer } from './toaster.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ToasterDispatcher } from './toaster.dispatcher';

const components = [ToasterComponent];

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ToasterEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
    ToastModule.forChild(),
  ],
  declarations: [...components],
  entryComponents: [...components],
  exports: [...components],
  providers: [ToasterDispatcher, ToasterStore, ToasterService],
})
export class ToasterModule {}
